import { registerNotification } from './registry'

registerNotification('script:stopped', {
  color: (_, theme) => theme.semantic.negative,
  icon:  () => 'error-full',
})